import script from "./ReadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadModal.vue?vue&type=script&setup=true&lang=js"

import "./ReadModal.vue?vue&type=style&index=0&id=26820cae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26820cae"]])

export default __exports__